/* globals UserProfileQuestionDTO */
export default class UserProfileQuestion {

    constructor(UserProfileQuestionDTO) {
        this.__userProfileQuestionDTO = UserProfileQuestionDTO;
        this.__showQuestionToUser = UserProfileQuestionDTO.ShowQuestionToUser;
        this.__isMobile = this.__userProfileQuestionDTO.isMobile;
        this.__Texts = this.__userProfileQuestionDTO.Texts;
        this.__detailList = this.__isMobile ? document.querySelector('.lista-resultados').firstElementChild : document.querySelector('.list-items');
        (this.__showQuestionToUser === 'True') && this.showQuestion();
    }

    checkFilter() {
        const itemValue = this.__isMobile ? document.getElementById('FiltrosViewModel_Filtros_FiltrosAvanzados').value : document.getElementById('js-filtros-avanzados').value;
        itemValue.includes('ascensor') && this.showQuestion();
    }

    showQuestion() {
        const CurrentNode = this.__isMobile ? document.querySelectorAll('.lista-resultados li[data-gtmlist]')[1] : document.querySelectorAll('.js-list-item')[2];
        let htmlContainer = document.createElement('div');

        this.__detailList.insertBefore(htmlContainer, CurrentNode);
        htmlContainer.classList.add("userprofile-question");
        htmlContainer.innerHTML = `<span>${this.__Texts.Important}<strong> ascensor</strong>?</span>
                                   <div class="userprofile-question-options">
                                   <input class="button" type="button" id="opt1" value="${this.__Texts.Prescindible}">
                                   <input style="margin:0 5px;" class="button" type="button" id="opt2" value="${this.__Texts.meGustaria}">
                                   <input class="button" type="button" id="opt3" value="${this.__Texts.Imprescindible}"></div>`;
      
        document.getElementById('opt1').addEventListener('click', () => {
            const data = encodeURIComponent('idFiltro') + '=' + encodeURIComponent(10) + '&' + encodeURIComponent('idRespuesta') + '=' + encodeURIComponent(1);
            fetch(this.__userProfileQuestionDTO.urlAnswer, {
                method: 'POST',
                body: data,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
            }).then(res => res.json())
            .then(response =>{
                if(response.Status!==200){
                    console.error(response.Message);
                }else{
                    this.showThanksMessage();
                }
            })
            .catch(error => console.error('Error:', error));
        });
        document.getElementById('opt2').addEventListener('click', () => {
            const data = encodeURIComponent('idFiltro') + '=' + encodeURIComponent(10) + '&' + encodeURIComponent('idRespuesta') + '=' + encodeURIComponent(2);
            fetch(this.__userProfileQuestionDTO.urlAnswer, {
                method: 'POST',
                body: data,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
            }).then(res => res.json())
            .then(response =>{
                if(response.Status!==200){
                    console.error(response.Message);
                }else{
                    this.showThanksMessage();
                }
            })
            .catch(error => console.error('Error:', error));
        });
        document.getElementById('opt3').addEventListener('click', () => {
            const data = encodeURIComponent('idFiltro') + '=' + encodeURIComponent(10) + '&' + encodeURIComponent('idRespuesta') + '=' + encodeURIComponent(3);
            fetch(this.__userProfileQuestionDTO.urlAnswer, {
                method: 'POST',
                body: data,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
            }).then(res => res.json())
            .then(response =>{
                if(response.Status!==200){
                    console.error(response.Message);
                }else{
                    this.showThanksMessage();
                }
            })
            .catch(error => console.error('Error:', error));
        });
    }

    showThanksMessage() {
        const userContainer = document.querySelector('.userprofile-question');
        let htmlContainer = document.createElement('div');

        htmlContainer.classList.add('thanks-message');
        htmlContainer.innerHTML = `<svg class="thanks-icon" role="presentation">
                                   <use xlink:href=${this.__userProfileQuestionDTO.okIcon} />
                                   </svg>
                                   <span>${this.__Texts.Thanks}</span>`;

        this.__detailList.replaceChild(htmlContainer, userContainer);
    }
}

/* jshint unused: false */
const UserProfileQuestionInstance = new UserProfileQuestion(UserProfileQuestionDTO);